import { Fragment } from "react";
import { Col } from "reactstrap";
import ButtonCommon from "../../../components/ButtonCommon";
import InputCommon from "../../../components/InputCommon";
import './../index.scss'

const NotEligible = () => {

    return (
        <Fragment>
            <div className="notEligible">
                <Col md={12}>
                    <h1>
                        Sorry, You’re not eligible basis the criteria set by our lending partner
                    </h1>
                    <h2>
                        Please check back after few months and continue to use <a href = "https://cleartax.in">ClearTax</a> software
                    </h2>
                </Col>
            </div>
        </Fragment>
    )
}

export default NotEligible;
